/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `day` - Day
 * * `night` - Overnight
 * * `24h` - 24 Hour
 */
export enum ShiftTypesEnum {
    DAY = 'day',
    NIGHT = 'night',
    _24H = '24h',
}
